/** @format */
import { stringify } from 'qs';

import { ModelSearchResultsSearchParams } from '@toucan/common/services/search/types';

export function getQueryStringFromSearchParams(
    searchParams: ModelSearchResultsSearchParams
) {
    const { selectedFilters, variants } = searchParams;

    const { productPrice } = variants ?? {};

    const selectedFiltersObject =
        typeof selectedFilters == 'object'
            ? (selectedFilters as Record<string, string>)
            : null;

    return stringify(
        {
            filterQuery: {
                productPrice: selectedFiltersObject?.productPrice,
                productConditionStarRating:
                    selectedFiltersObject?.productConditionStarRating,
            },
            productPrice,
        },
        {
            addQueryPrefix: true,
        }
    );
}
